function watchRefineModal(targetNode) {
  const observer = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class' && targetNode.classList.contains('boost-pfs-filter-tree-mobile-open')) {
        changeZIndex(9);
      } else {
        changeZIndex(2);
      }
    }
  });
  observer.observe(targetNode, { attributes: true });
}
function changeZIndex(number) {
  const mainNode = document.querySelector('#MainContent');
  mainNode.style.zIndex = number;
}

document.addEventListener('DOMContentLoaded', () => {
  changeZIndex(1)
  const targetNode = document.querySelector('#boost-pfs-filter-tree');
  if (targetNode) {
    watchRefineModal(targetNode);
  }
});